import { render, staticRenderFns } from "./change-election.vue?vue&type=template&id=d00f1b78&scoped=true"
import script from "./change-election.vue?vue&type=script&lang=js"
export * from "./change-election.vue?vue&type=script&lang=js"
import style0 from "./change-election.vue?vue&type=style&index=0&id=d00f1b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f1b78",
  null
  
)

export default component.exports